import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <footer className="footer__area">
      <div className="footer__top">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="footer__widget">
                <div className="logo mb-35">
                  <Link to="/">
                    <img src="/images/sys-white-logo.png" alt="img" />
                  </Link>
                </div>
                <div className="footer__content">
                  <p>
                    Empowering you with affordable, expert-led online courses to boost your
                    career. Our mission is to make learning simple, accessible, and fun for
                    everyone.
                  </p>
                  <ul className="list-wrap">
                    <li>
                      Office No 204 Shree Ganesh Galaxy, Alandi-Pune Road Wadmukhwadi,Pune. PinCode - 411081
                    </li>
                    <li />
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h4 className="footer__widget-title">Useful Links</h4>
                <div className="footer__link">
                  <ul className="list-wrap">
                    <li>
                      <a href="events-details.html">Our values</a>
                    </li>
                    <li>
                      <a href="events-details.html">Our advisory board</a>
                    </li>
                    <li>
                      <a href="events-details.html">Our partners</a>
                    </li>
                    <li>
                      <a href="events-details.html">Become a partner</a>
                    </li>
                    <li>
                      <a href="events-details.html">Work at Future Learn</a>
                    </li>
                    <li>
                      <a href="events-details.html">Quizlet Plus</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h4 className="footer__widget-title">Our Company</h4>
                <div className="footer__link">
                  <ul className="list-wrap">
                    <li>
                      <Link to="/contactus">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/mentor-register">Mentor Register</Link>
                    </li>
                    <li>
                      <Link to="/college-register">College Register</Link>
                    </li>
                    <li>
                      <Link to="/programs">Program</Link>
                    </li>
                    <li>
                      <Link to="/kids">Kids</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="footer__widget">
                <h4 className="footer__widget-title">Get In Touch</h4>
                <div className="footer__contact-content">
                  <p>
                   Your next step in tech starts here.Let’s connect and create.
                  </p>
                  <ul className="list-wrap footer__social" style={{ display: 'flex', gap: '10px' }}>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                        <FaFacebookF style={{ color: '#fff', fontSize: '18px' }} />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/sysinsightsolutions/" target="_blank" rel="noopener noreferrer">
                        <FaInstagram style={{ color: '#fff', fontSize: '18px' }} />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/sysinsight-solutions/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
                        <FaLinkedinIn style={{ color: '#fff', fontSize: '18px' }} />
                      </a>
                    </li>
                  </ul>
                </div>
                {/* <div className="app-download">
                  <a href="#">
                    <img src="assets/img/others/google-play.svg" alt="img" />
                  </a>
                  <a href="#">
                    <img src="assets/img/others/apple-store.svg" alt="img" />
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <div className="copy-right-text">
                <p>
                  ©2025 <a href="https://sysinsightsolutions.com/" target="_blank" rel="noopener noreferrer">sysinsightsolutions.com</a>. All rights reserved.
                </p>
              </div>
            </div>
            {/* <div className="col-md-5">
              <div className="footer__bottom-menu">
                <ul className="list-wrap">
                  <li>
                    <a href="contact.html">Term of Use</a>
                  </li>
                  <li>
                    <a href="contact.html">Privacy Policy</a>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  )
}
export default Footer;